import { Component, ElementRef, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from 'app/components/header/header.component';
import { FooterComponent } from 'app/components/footer/footer.component';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-sme',
  standalone: true,
  imports: [
    CommonModule,
    HeaderComponent,
    FooterComponent,
    TranslateModule,
    RouterModule,
  ],
  templateUrl: './sme.component.html',
})
export class SmeComponent implements OnInit {
  elementRef = inject(ElementRef);
  selectedLanguage: any;
  supportSections = [
    {
      id: 'section1',
      title: 'SME_PAGE.HERO.ITEMS.0',
      logoSrc: '/assets/images/customer-journey.jpg', 
    },
    {
      id: 'section2',
      title: 'SME_PAGE.HERO.ITEMS.1',
      logoSrc: '/assets/images/financial-advisory.jpg', 
    },
    {
      id: 'section3',
      title: 'SME_PAGE.HERO.ITEMS.2',
      logoSrc: '/assets/images/guides.jpg', 
    },
  ];
  guide = [
    {
      icon: '/assets/images/icons/pen.jpg',
      title: 'Applying for the right financing/loan',
      description: '',
      items: [
        'Identify your ability to repay the amount of financing/loan​',
        'Determine the amount your business needs​',
        'Ensure that your business revenue can cover your operating expenses, loan repayment​ and financing.',
        'Prepare the required documentation​',
        'Look for the right product match on imSME.com.my or use our product matching tool​',
        'Register for a user account and apply.',
      ]
    },
    {
      icon: '/assets/images/icons/money.jpg',
      title: 'Meeting the financing/loan eligibility requirements',
      description: 'Requirements required by most banks when processing a SME business financing/loan application include:​',
      items: [
        'Applicant must be a Malaysian citizen aged 21 years and above ',
        'The business must be registered and/ or licensed in Malaysia ',
        'The business entity consist of either of Sole Proprietorship/ Partnership/ Limited Liability Partnership/Sendirian Berhad/ Individual/ Professional Bodies',
        'The business has been in operations for at least three (3) years.',
      ]
    },
    {
      icon: '/assets/images/icons/accounting.jpg',
      title: 'How do financial institutions evaluate eligible applicants?​',
      description: 'Factors which may influence your eligibility include:',
      items: [
        'Ability to repay your financing/loan​',
        'Showing stable business revenue or consistent profits.​'
      ]
    }
  ];
  activeSection = this.supportSections[0].id;

  ngOnInit(): void {
    this.selectedLanguage = this.readLocalStorageValue('language');
  }

  scroll(targetId: string) {
    this.activeSection = targetId;
    const element = this.elementRef.nativeElement.querySelector(`#${targetId}`);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    }
  }

  switchedLanguage(data: any) {
    this.selectedLanguage = data;
  }

  readLocalStorageValue(key: string) {
    let value = localStorage.getItem(key);
    return value;
  }
}
